module.exports = __webpack_public_path__ + "static/media/harvard-logo.88c5c66a.png";